import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import home from "../../Assets/AppComponent/Logo/Home.svg";
import Header from "../../Component/AppComponent/Header/Header";
import { setGraphListRetrieveActions } from "../../Redux/Slice";
import BarChart from "../../Component/AppComponent/Charts/BarChart";
import Select from "react-dropdown-select";
import { addDays, isAfter } from "date-fns";
import { DateRangePicker } from "rsuite";
import "./styles/Graphs.scss";
import {
  dropdownCustomStyles,
  formatInRupees,
  getDefaultDateRange,
  handleDateChange,
  predefinedDateRanges,
} from "./common/graphUtils";
import { exportAmountsApi } from "../../Context/apidata";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { FaRegFilePdf } from "react-icons/fa6";

function Graphs() {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [plantNameFeeder, setPlantNameFeeder] = useState([]);
  const [plantSelected, setPlantSelected] = useState(undefined);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Get data from Redux store with proper error handling
  const graphListRetrieve = useSelector(
    (state) => state.graphListRetrieveData?.graphListRetrieve || [],
  );

  const graphError = useSelector(
    (state) => state.graphListRetrieveReducer?.Error,
  );

  // Chart states
  const [chartData, setChartData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const formatDate = (date) => date.toISOString().slice(0, 10);

  const [apiCallAttempted, setApiCallAttempted] = useState(false);
  const [range, setRange] = useState([
    formatDate(new Date("2025-04-09")),
    formatDate(new Date()),
  ]);
  const [totalAmount, setTotalAmount] = useState(0);

  // Fetch graph data from API when component mounts
  useEffect(() => {
    fetchGraphData();
    return () => {
      console.log("Component unmounting, cleaning up");
    };
  }, [plantSelected, range]);

  // Process API data when it changes
  useEffect(() => {
    if (graphListRetrieve && graphListRetrieve.length > 0) {
      setChartData(graphListRetrieve);
      setIsLoading(false);
    } else {
      setChartData([]);
      setIsLoading(false);
    }
  }, [graphListRetrieve, graphError, apiCallAttempted]);

  // Calculate total amount whenever chart data changes
  useEffect(() => {
    const total = chartData.reduce((sum, item) => sum + item.amount, 0);
    setTotalAmount(total);
  }, [chartData]);

  // Function to fetch graph data from API
  const fetchGraphData = () => {
    setIsLoading(true);
    setApiCallAttempted(true);
    dispatch(
      setGraphListRetrieveActions({
        filter: "plant",
        ...(plantSelected ? { plant_id: plantSelected?.[0]?.value } : {}),
        ...(range[0] && range[1]
          ? { from_date: range[0], to_date: range[1] }
          : {}),
      }),
    );
  };

  // Handle bar chart click to navigate to projects view
  const handleBarClick = (item) => {
    console.log("Bar clicked:", item);
    if (item && item.plant_id) {
      navigate(`/graphs/${item.plant_name}/${item.plant_id}`);
    }
  };

  // Breadcrumbs for navigation
  const breadcrumbsData = [
    {
      id: "1",
      href: "/",
      source: home,
      title: "DASHBOARD",
    },
  ];

  // Set plant names from Redux store
  const plantNames = useSelector(
    (state) => state.plantListgetdropdata.plantListgetdrop,
  );

  useEffect(() => {
    setPlantNameFeeder(plantNames);
  }, [plantNames]);

  const excelDownload = (type) => {
    const params = new URLSearchParams();
    params.append("filter", "plant");
    params.append("export_type", type);

    if (plantSelected?.[0]?.value) {
      params.append("plant_id", plantSelected[0].value);
    }
    if (range[0] && range[1]) {
      params.append("from_date", range[0]);
      params.append("to_date", range[1]);
    }
    const url = `${exportAmountsApi}?${params.toString()}`;
    window.open(url, "_blank");
  };

  return (
    <div
      className={`${
        stateDisplay ? "outterContent" : "inner-Content"
      } graphs-container`}
      style={{ minHeight: "87vh" }}
    >
      <Header breadCrumbsData={breadcrumbsData} heading="Plant - Summary" />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {/* Controls Section */}
        <div className="graphs-container__controls" style={{ width: "auto" }}>
          {/* Total Amount Display */}
          <div className="graphs-container__total-display">
            <span className="graphs-container__total-display-label">
              Total:{" "}
            </span>
            {isLoading ? (
              <span>Loading...</span>
            ) : (
              <span>{formatInRupees(totalAmount)}</span>
            )}
          </div>

          {/* Filters Section */}
        </div>
        <div className="graphs-container__filters">
          {/* Plant Selection Dropdown */}
          <div className="graphs-container__select">
            <Select
              className="Selects"
              styles={dropdownCustomStyles}
              clearable={plantSelected?.length > 0}
              onChange={(e) => setPlantSelected(e)}
              name="plant"
              id="plant"
              options={plantNameFeeder?.map(({ id, plant }) => ({
                value: id,
                label: plant,
              }))}
              value={plantSelected}
            />
          </div>

          {/* Date Range Picker */}
          <DateRangePicker
            defaultValue={[new Date("2025-04-09"), new Date()]}
            placement="auto"
            shouldDisableDate={(date) =>
              isAfter(date, new Date()) || date < new Date("2025-04-08")
            }
            editable={false}
            appearance="default"
            size="lg"
            ranges={predefinedDateRanges}
            placeholder="From - To"
            style={{ width: 300, float: "right" }}
            onChange={(e) => handleDateChange(setRange, e)}
          />
          {/* <button
            className="download"
            onClick={(e) => {
              excelDownload();
            }}
          >
            Download Excel
          </button> */}
          <div className="split-download" ref={dropdownRef}>
            {/* Default Button */}
            <button
              className="main-btn"
              onClick={() => {
                excelDownload("excel");
              }}
              style={{
                background:
                  "linear-gradient(90deg, #F26639 -3.66%, #F79C37 -3.65%, #EF4D39 100.34%)",
              }}
            >
              Download Excel
            </button>

            {/* Arrow Button */}
            <button className="arrow-btn" onClick={() => setOpen(!open)}>
              ▼
            </button>

            {/* Dropdown */}
            {open && (
              <div className="downloadDropdown">
                <div
                  className="downloadDropdown-item"
                  onClick={() => {
                    excelDownload("excel");
                    setOpen(false);
                  }}
                >
                  <PiMicrosoftExcelLogoFill size={22} color="#F26639" />
                  Excel
                </div>
                <div
                  className="downloadDropdown-item"
                  onClick={() => {
                    excelDownload("pdf");
                    setOpen(false);
                  }}
                >
                  <FaRegFilePdf size={20} color="#F26639" />
                  PDF
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Chart Section */}
      <div>
        <div className="graphs-container__chart-wrapper">
          <div className="graphs-container__chart">
            <BarChart
              data={chartData}
              xAxisLabel="Plant Name"
              yAxisLabel="Amount (₹)"
              currencySymbol="₹"
              onBarClick={handleBarClick}
              barWidth={50}
              showXAxisLabel={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Graphs;
